import React from 'react';
import { HorizontalBar } from 'react-chartjs-2';
import { Box, Typography, Grid } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const LitigeInvoicesRates = () => {
	const { t } = useTranslation();
    const indicators = useSelector(
        ({ requests }) =>
            requests.queries.FETCH_COUNT_INVOICE_INDICATOR &&
            requests.queries.FETCH_COUNT_INVOICE_INDICATOR.data
    );

    // Safe access to values
    const rateExported = indicators?.rateOfExportedInvoices || 0;
    const rateLitige = indicators?.rateOfLitigeInvoices || 0;
    const rateRejected = indicators?.rateOfRejectedInvoices || 0;
    const totalRate = rateExported + rateLitige + rateRejected;

    const isDataEmpty = totalRate === 0;

    const data = {
        labels: ['Status'],
        datasets: isDataEmpty 
            ? [
                {
                    label: t("no_data"),
                    data: [100],
                    backgroundColor: '#e0e0e0',
                    hoverBackgroundColor: '#e0e0e0',
                }
            ]
            : [
                {
                    label: t("resolved_exp"),
                    data: [rateExported],
                    backgroundColor: '#4caf50',
                },
                {
                    label: t("in_progress"),
                    data: [rateLitige],
                    backgroundColor: '#ff9800',
                },
                {
                    label: t("rejected"),
                    data: [rateRejected],
                    backgroundColor: '#f44336',
                }
            ]
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        devicePixelRatio: window.devicePixelRatio || 2,
        events: [],
        hover: { mode: null },
        tooltips: { enabled: false },
        scales: {
            xAxes: [{
                stacked: true,
                display: false,
                ticks: { beginAtZero: true, max: 100 }
            }],
            yAxes: [{ stacked: true, display: false }]
        },
        legend: { display: false }
    };

    return (
        <Box p={2} display="flex" flexDirection="column">
            <Typography variant="subtitle1" color='primary' gutterBottom style={{marginBottom:'15px'}}>
                {t("dispute_management")}
            </Typography>
            
            <Grid container alignItems="center" spacing={2}>
                <Grid item xs={3} style={{ textAlign: 'center' }}>
                    <Typography variant="h4" style={{ fontWeight: '500' }}>
                        {indicators?.rateOfGlobalLitige || 0}%
                    </Typography>
                    <Typography variant="caption" color="textSecondary">
                        {t("dispute_rate")}
                    </Typography>
                </Grid>

                <Grid item xs={9}>
                    <Box height={40} width="100%" position="relative" style={{marginBottom: '10px'}}>
                        <HorizontalBar data={data} options={options} />
                    </Box>
                    
                    <Box display="flex" justifyContent="space-between" mt={1}>
                        <LegendItem color="#4caf50" label={t("resolved_exp")} value={rateExported} />
                        <LegendItem color="#ff9800" label={t("in_progress")} value={rateLitige} />
                        <LegendItem color="#f44336" label={t("rejected")} value={rateRejected} />
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

const LegendItem = ({ color, label, value }) => (
    <Box display="flex" alignItems="center">
        <div style={{ width: 10, height: 10, backgroundColor: color, marginRight: 4 }} />
        <Typography variant="caption" color='primary' style={{ fontSize: '0.75rem' }}>
            {label} {value}%
        </Typography>
    </Box>
);

export default LitigeInvoicesRates;
